import { types } from "mobx-state-tree";

export default types.model("User", {
  id: types.number,
  email: types.string,
});
